import { render, staticRenderFns } from "./mapbox-map-card.vue?vue&type=template&id=70f98cfe"
import script from "./mapbox-map-card.vue?vue&type=script&lang=js"
export * from "./mapbox-map-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports